import React from 'react'
import { useFormContext } from 'react-hook-form'

export default function InputXL({ placeholder, width }) {
  const { register } = useFormContext()

  return (
    <div className='w-full flex justify-center'>
      <input
        autoComplete='off'
        {...register('xxlField', {
          validate: {
            hasValidationError: (v) => {
              const errorList = []
              let hasError = false

              if (v?.length > 0) {
                const re = new RegExp('^[0-9a-zA-ZñÑ.-]*$')
                if (!re.test(v)) {
                  errorList.push('specialChars')
                  hasError = true
                }

                if (v.includes('ñ') || v.includes('Ñ')) {
                  errorList.push('hasEne')
                  hasError = true
                }

                if (v?.length < 6 || v?.length > 20) {
                  errorList.push('range')
                  hasError = true
                }
              } else {
                errorList.push('empty')
                hasError = true
              }

              return hasError ? errorList.toString() : false
            }
          }
        })}
        type='text'
        placeholder={placeholder}
        className={` ${
          width || 'w-full'
        } text-3xl font-bold text-center text-black h-14 bg-transparent border-gray-600 border-b-1 border-t-0 border-l-0 border-r-0 border-x-transparent focus:border-x-transparent focus:ring-0`}
      />
    </div>
  )
}
